import { useState } from "react";
import "./App.css"
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import Alert from "./components/Alert";


export default function App() {
  const [mode, setMode] = useState('light');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{
      setAlert(null);
    }, 1000)
  }

  const toggleMode = ()=>{
    if(mode==='light'){
      setMode ('dark');
      document.body.style.background = "#202124"
      showAlert("Dark mode has been enabled", "success")
    } else {
      setMode ('light') 
      document.body.style.background = "white"
      showAlert("Light mode has been enabled", "success")
    }
  }
  return (
    <div>
      <Navbar title = "Text Editor" mode={mode} toggleMode = {toggleMode}/>
      <Alert alert = {alert}/>
      <div className="container my-3">
      <TextForm showAlert={showAlert} heading="Enter the text below" mode={mode} />
      </div>
    </div>
  );
}
